import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Section, Flex } from '../components/common'

const Pass = styled.input`
  margin: auto;
  border: 1px solid black;
`

const PassInput = ({onChange}) => (
  <Section>
    <Flex grow>
      <Pass name='protected' type='password' onChange={onChange} />
    </Flex>
  </Section>
)

PassInput.propTypes = {
  onChange: PropTypes.func.isRequired
}

export default PassInput



// WEBPACK FOOTER //
// ./src/views/Pass.js